import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "position-history-new",
  components: {
    AppHeader
  },
  async created() {
    this.getLatestHistory();
    await this.getUser();
    this.getPosition();
    await this.getTodayDate();
  },
  data() {
    return {
      canChoiceYears: [],
      dayCount: "",
      changeYear: "",
      changeMonth: "",
      changeDay: "",
      positionHistory: {
        user_id: this.$route.params.user_id,
        position_id_before: "",
        position_name_before: "",
        position_id_after: "",
        position_name_after: "",
        authority: ""
      },
      user: "",
      positions: "",
      getPositionsEnd: false,
      latestHistory: null,
      savingFlag: false
    };
  },
  computed: {
    changeDateFormat() {
      return dayjs(
        `${this.changeYear}-${this.changeMonth}-${this.changeDay}`
      ).format("YYYY-MM-DD");
    },
    changeDateBeforeToday() {
      if (this.changeYear && this.changeMonth && this.changeDay) {
        if (this.changeDateFormat <= dayjs().format("YYYY-MM-DD")) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    changeDateBeforeLatest() {
      if (this.changeYear && this.changeMonth && this.changeDay) {
        if (
          this.latestHistory == null ||
          this.changeDateFormat >
            dayjs(this.latestHistory.change_date).format("YYYY-MM-DD")
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    isSamePositions() {
      if (this.user.position_id == this.positionHistory.position_id_after) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    async getUser() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_USER", {
          id: this.$route.params.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.user = res.user;
    },
    async getLatestHistory() {
      let data = {
        user_id: this.$route.params.user_id
      };
      let res = await this.$store
        .dispatch("GET_LATEST_POSITION_HISTORY", {
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.latestHistory = res.latest_history;
    },
    async getPosition() {
      let data = {
        company_id: this.user.company_id
      };
      let res = await this.$store
        .dispatch("GET_POSITION", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.positions = res.positions;
      this.getPositionsEnd = true;
    },
    getTodayDate() {
      let today = new Date();
      let currentYear = today.getFullYear();
      for (let i = 0; i < 60; i++) {
        this.canChoiceYears.push(currentYear - i);
      }
      this.dayCount = new Date(this.changeMonth, this.changeDay, 0).getDate();
    },
    async createPositionHistory() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      this.positionHistory.change_date = this.changeDateFormat;
      this.positionHistory.position_id_before = this.user.position_id;
      this.positionHistory.position_name_before = this.user.position_name;
      let findPosition = this.positions.find(
        position => position.id == this.positionHistory.position_id_after
      );
      this.positionHistory.position_name_after = findPosition.name;
      let data = this.positionHistory;
      let res = await this.$store
        .dispatch("CREATE_POSITION_HISTORY", {
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.goPositionHistory();
      }
    },
    changePosition() {
      let findPosition = this.positions.find(
        position => position.id == this.positionHistory.position_id_after
      );
      this.positionHistory.authority = findPosition.default_authority;
    },
    goUserDetail() {
      this.$router.push({ path: `/user/${this.$route.params.user_id}` });
    },
    goPositionHistory() {
      this.$router.push({
        path: `/position_history/${this.$route.params.user_id}`
      });
    },
    getDayCount() {
      this.changeDay = "";
      this.dayCount = new Date(this.changeYear, this.changeMonth, 0).getDate();
    }
  }
};
